import { Box, Typography, styled } from '@mui/material';
import type { IAppDetailsAppData } from '../common-types';
import { CategoryList } from '../AppDetails';

const Container = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(3)} 0`,
}));

type ConditionAreasProps = {
  app: IAppDetailsAppData;
  translatedText: {
    conditionAreasHeading: string;
  };
};

/**
 * ConditionAreas from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param translatedText is required, this is the text that as already been translated by the consumer of this component.
 */
export const ConditionAreas = ({
  app,
  translatedText,
  ...props
}: ConditionAreasProps) => {
  const { healthCategories } = app ?? {};
  return (
    <>
      {healthCategories && healthCategories.length > 0 && (
        <Container {...props}>
          <Box sx={{ display: 'grid', gap: (theme) => theme.spacing(3) }}>
            <Typography component="h2" variant="h6">
              {translatedText?.conditionAreasHeading}
            </Typography>

            <Box sx={{ display: 'grid', gap: (theme) => theme.spacing(1.5) }}>
              {healthCategories.map((category) => {
                return (
                  <CategoryList
                    key={category.name}
                    items={category.subCategories}
                    leadItem={category.name}
                  />
                );
              })}
            </Box>
          </Box>
        </Container>
      )}
    </>
  );
};
